export default __webpack_public_path__ + "static/media/reflect.7b25ca70.png";